import { Dispatch, FC, SetStateAction, useState } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  FormControlLabel, Stack, Switch, TableCell, TableRow, Box, Card, CardContent,
  List, ListItem, ListItemText, Divider, Menu, MenuItem, Typography
} from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import { FirstNiveau, IUserRef, SecondNiveau } from "./Article";
import { cellStyle } from "../Pays/RowPays";
import { LoadingButton } from "@mui/lab";
import { AxiosInstance } from "axios";
import ArticleForm from "../../../forms/article/ArticleForm";
import { IPays } from "../Pays/Pays";
import { DataRef } from "../../../../types/DataRef";
import { ClientWithChildInterface, DeviseInterface } from "./InterfaceArticle";
import DuplicateArticleForm from "../../../forms/article/DuplicateArticleForm";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import { AlertType } from "../../../../types/AlertType";
import DuplicateCoutsByArticle from "../../../forms/article/DuplicateCoutsByArticle";
import DuplicateTarifByArticle from "../../../forms/article/DuplicateTarifByArticle";
import ChangeStatusConfirmation from "../../../element/ChangeStatusConfirmation";
import DesactiveDateModal from "../../../element/DesactiveDateModal";
import { deviseIds_fixed3 } from "../../../../constants/Constants";

interface SecondNiveauProps {
  isDesktopOrLaptop: boolean;
  dataRefPaysBu: IPays[];
  alltype: DataRef[];
  allActivite: DataRef[];
  allDevise: DeviseInterface[];
  allClientWithChild: ClientWithChildInterface[];
  firstNiveau: FirstNiveau;
  secondNiveau: SecondNiveau;
  http: AxiosInstance;
  setOpenSnack: Dispatch<SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<SetStateAction<string>>;
  setAlertType: Dispatch<SetStateAction<AlertType>>;
  RereshDataArticle: () => void;
  allUserGRCCommerciaux: IUserRef[];
}

type DUPLICATE = 'EDIT' | 'DELETE' | 'DUP_ARTICLE' | 'DUP_TARIF' | 'DUP_COUT';

const ITEM_HEIGHT = 48;

const SecondNiveauArticle: FC<SecondNiveauProps> = ({
  isDesktopOrLaptop,
  allActivite,
  allDevise,
  alltype,
  dataRefPaysBu,
  RereshDataArticle,
  allClientWithChild,
  firstNiveau,
  secondNiveau,
  http,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  allUserGRCCommerciaux
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [openDuplicateModal, setOpenDuplicateModal] = useState<boolean>(false);
  const [desactiveDateModal, setDesactiveDateModal] = useState<boolean>(false);
  const [openDuplicateModalTarif, setOpenDuplicateModalTarif] = useState<boolean>(false);
  const [openDuplicateModalCout, setOpenDuplicateModalCout] = useState<boolean>(false);

  const [changeStatut, setChangeStatut] = useState<boolean>(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMoreMenu = () => {
    setAnchorEl(null);
  };

  const handleDelete = (): void => {
    setDeleteLoading(true);
    http.get(`delete/article/${secondNiveau?.id}`)
      .catch(error => {
        console.log(error);
      }).finally(() => {
        setOpenModalDelete(false);
        setDeleteLoading(false);
        RereshDataArticle();
      });
  };

  const handleCloseDuplicateModal = () => {
    setOpenDuplicateModal(false);
  };

  const handleCloseDeleteConfirmation = (): void => {
    setOpenModalDelete(false);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleChangeState = () => {
    secondNiveau?.actif ? setDesactiveDateModal(true) : setChangeStatut(true);
  };

  const handleClose1 = () => {
    setChangeStatut(false);
  };

  const handleClose2 = () => {
    setDesactiveDateModal(false);
  };

  const handleClickDuplicate = (item: DUPLICATE) => {
    switch (item) {
      case 'EDIT':
        setOpenModal(true);
        break;
      case 'DELETE':
        setOpenModalDelete(true);
        break;
      case 'DUP_ARTICLE':
        setOpenDuplicateModal(true);
        break;
      case 'DUP_TARIF':
        setOpenDuplicateModalTarif(true);
        break;
      case 'DUP_COUT':
        setOpenDuplicateModalCout(true);
        break;
    }

    handleCloseMoreMenu();
  };

  const confirmMsgForStatut = `Vous êtes sur le point ${secondNiveau?.actif ? "de désactiver" : "d'activer"} cet article, êtes-vous sûr de vouloir poursuivre cette action ?`;

  const url = `article/change-statut/${secondNiveau?.id}`;

  return (
    <>
      {isDesktopOrLaptop ? (
        <TableRow>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.pays_libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.bu_libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.client_libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.code_article_libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.tarifheure && (deviseIds_fixed3.includes(secondNiveau?.devise_id) ? parseFloat(secondNiveau?.tarifheure as string).toFixed(3) : parseFloat(secondNiveau?.tarifheure as string).toFixed(2))}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.tarifacte && (deviseIds_fixed3.includes(secondNiveau?.devise_id) ? parseFloat(secondNiveau?.tarifacte as string).toFixed(3) : parseFloat(secondNiveau?.tarifacte as string).toFixed(2))}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {secondNiveau?.coutactivite}
          </TableCell>
          <TableCell style={cellStyle} align="center" width={395}>
            <Stack
              direction="row"
              spacing={1}
              display="flex"
              justifyContent="center"
              py={1}
            >
              <Stack
                direction="column"
                spacing={1}
                display="flex"
                justifyContent="center"
              >
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<BorderColorIcon />}
                  onClick={() => setOpenModal(true)}
                  sx={btnStyle({
                    bgColor: "#070d23",
                    hoverColor: "Gray",
                    color: "#fff",
                  })}
                  disabled={!secondNiveau?.actif}
                >
                  Modifier
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="warning"
                  startIcon={<ContentCopyIcon />}
                  sx={{ textTransform: "none" }}
                  onClick={() => setOpenDuplicateModal(true)}
                  disabled={!secondNiveau?.actif}
                >
                  Dupl. Article
                </Button>
              </Stack>

              <Stack
                direction="column"
                spacing={1}
                display="flex"
                justifyContent="center"
              >
                <Button
                  size="small"
                  variant="outlined"
                  sx={btnStyle({
                    bgColor: "#FF0000",
                    hoverColor: "#FE3737",
                  })}
                  startIcon={<DeleteIcon />}
                  onClick={() => setOpenModalDelete(true)}
                  disabled={secondNiveau?.has_saisie || !secondNiveau?.actif}
                >
                  Supprimer
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="warning"
                  startIcon={<ContentCopyIcon />}
                  sx={{ textTransform: "none" }}
                  onClick={() => setOpenDuplicateModalTarif(true)}
                  disabled={(secondNiveau.tar_date_fin !== null) || !secondNiveau?.actif}
                >
                  Dupl. Tarif
                </Button>
              </Stack>

              <Stack
                direction="column"
                spacing={1}
                display="flex"
                justifyContent="center"
              >
                <FormControlLabel
                  sx={{ mt: 1, color: "#818181" }}
                  control={
                    <Switch
                      name="consentement"
                      checked={secondNiveau?.actif}
                      onChange={() => handleChangeState()}
                      color="warning"
                      size="small"
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label={secondNiveau?.actif ? "Activer" : "Désactiver"}
                />
                <Box pt={0.8}>
                  <Button
                    size="small"
                    variant="contained"
                    color="warning"
                    startIcon={<ContentCopyIcon />}
                    sx={{ textTransform: "none" }}
                    onClick={() => setOpenDuplicateModalCout(true)}
                    disabled={(secondNiveau.couts_date_fin !== null) || !secondNiveau?.actif}
                  >
                    Dupl. Couts
                  </Button>
                </Box>
              </Stack>
            </Stack>
          </TableCell>
        </TableRow>
      ) : (
        <Card>
          <CardContent>
            <List dense>
              <ListItem dense>
                <ListItemText
                  primary="Pays :"
                  secondary={
                    <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                      {secondNiveau?.pays_libelle}
                    </Typography>
                  }
                />
              </ListItem>
              <Divider orientation="horizontal" sx={{ bgcolor: "#dfdfdf" }} />
              <ListItem dense>
                <ListItemText
                  primary="BU :"
                  secondary={
                    <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                      {secondNiveau?.bu_libelle}
                    </Typography>
                  }
                />
              </ListItem>
              <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
              <ListItem dense>
                <ListItemText
                  primary="Client :"
                  secondary={
                    <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                      {secondNiveau?.client_libelle}
                    </Typography>
                  }
                />
              </ListItem>
              <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
              <ListItem dense>
                <ListItemText
                  primary="Code articles :"
                  secondary={
                    <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                      {secondNiveau?.code_article_libelle}
                    </Typography>
                  }
                />
              </ListItem>
              <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
              <ListItem dense>
                <ListItemText
                  primary="Désignation Article :"
                  secondary={
                    <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                      {secondNiveau?.libelle}
                    </Typography>
                  }
                />
              </ListItem>

              {secondNiveau?.tarifheure ? (
                <>
                  <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                  <ListItem dense>
                    <ListItemText
                      primary="Tarif Heures :"
                      secondary={
                        <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                          {secondNiveau?.tarifheure}
                        </Typography>
                      }
                    />
                  </ListItem>
                </>
              ) : null}

              {secondNiveau?.tarifacte ? (
                <>
                  <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                  <ListItem dense>
                    <ListItemText
                      primary="Tarif Actes :"
                      secondary={
                        <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                          {secondNiveau?.tarifacte}
                        </Typography>
                      }
                    />
                  </ListItem>
                </>
              ) : null}

              <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
              <ListItem dense>
                <ListItemText
                  primary="Coûts :"
                  secondary={
                    <Typography sx={{ fontSize: 12, color: '#9e9e9e' }}>
                      {secondNiveau?.coutactivite}
                    </Typography>
                  }
                />
              </ListItem>

              <Box display="flex" justifyContent="space-between" mt={2}>
                <FormControlLabel
                  sx={{ color: "#818181" }}
                  control={
                    <Switch
                      name="consentement"
                      checked={secondNiveau?.actif}
                      onChange={() => handleChangeState()}
                      color="warning"
                      size="small"
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label={secondNiveau?.actif ? "Activer" : "Désactiver"}
                />

                <Box>
                  <Button
                    variant="text"
                    sx={{
                      textTransform: 'none',
                      color: '#9e9e9e'
                    }}
                    size="small"
                    endIcon={<MoreVertIcon />}
                    onClick={handleClick}
                  >
                    Action
                  </Button>

                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCloseMoreMenu}
                    PaperProps={{
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                      },
                    }}
                  >
                    <MenuItem
                      dense
                      onClick={() => handleClickDuplicate("EDIT")}
                    >
                      Modifier Article
                    </MenuItem>
                    <MenuItem
                      dense
                      disabled={secondNiveau?.has_saisie || !secondNiveau?.actif}
                      onClick={() => handleClickDuplicate("DELETE")}
                    >
                      Supprimer Article
                    </MenuItem>
                    <MenuItem
                      dense
                      disabled={!secondNiveau?.actif}
                      onClick={() => handleClickDuplicate("DUP_ARTICLE")}
                    >
                      Dupliquer Article
                    </MenuItem>
                    <MenuItem
                      dense
                      disabled={(secondNiveau.tar_date_fin !== null) || !secondNiveau?.actif}
                      onClick={() => handleClickDuplicate("DUP_TARIF")}
                    >
                      Dupliquer Tarif
                    </MenuItem>
                    <MenuItem
                      dense
                      disabled={!secondNiveau?.actif}
                      onClick={() => handleClickDuplicate("DUP_COUT")}
                    >
                      Dupliquer Couts
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>
            </List>
          </CardContent>
        </Card>
      )}

      <OptionalWidthModal
        title="Modifier un Article"
        onClose={() => setOpenModal(false)}
        open={openModal}
        breackPoint="md"
      >
        <ArticleForm
          dataRefPaysBu={dataRefPaysBu}
          allActivite={allActivite}
          allDevise={allDevise}
          alltype={alltype}
          allClientWithChild={allClientWithChild}
          firstNiveau={firstNiveau}
          secondNiveau={secondNiveau}
          onClose={handleClose}
          reloadList={RereshDataArticle}
          allUserGRCCommerciaux={allUserGRCCommerciaux}
        />
      </OptionalWidthModal>

      <OptionalWidthModal
        title="Dupliquer un Article"
        onClose={handleCloseDuplicateModal}
        open={openDuplicateModal}
        breackPoint="md"
      >
        <DuplicateArticleForm
          firstNiveau={firstNiveau}
          secondNiveau={secondNiveau}
          dataRefPaysBu={dataRefPaysBu}
          allActivite={allActivite}
          allDevise={allDevise}
          alltype={alltype}
          onClose={handleCloseDuplicateModal}
          allClientWithChild={allClientWithChild}
          allUserGRCCommerciaux={allUserGRCCommerciaux}
        />
      </OptionalWidthModal>

      <OptionalWidthModal
        title="Dupliquer un tarif"
        breackPoint="md"
        onClose={() => {
          setOpenDuplicateModalTarif(false);
        }}
        open={openDuplicateModalTarif}
      >
        <DuplicateTarifByArticle
          articleSecond={secondNiveau}
          onClose={() => {
            setOpenDuplicateModalTarif(false);
          }}
          openModal={openDuplicateModalTarif}
          reloadList={RereshDataArticle}
        />
      </OptionalWidthModal>

      <OptionalWidthModal
        title="Dupliquer un couts"
        breackPoint="md"
        onClose={() => {
          setOpenDuplicateModalCout(false);
        }}
        open={openDuplicateModalCout}
      >
        <DuplicateCoutsByArticle
          articleSecond={secondNiveau}
          onClose={() => {
            setOpenDuplicateModalCout(false);
          }}
          openModal={openDuplicateModalCout}
          reloadList={RereshDataArticle}
        />
      </OptionalWidthModal>

      <Dialog
        open={openModalDelete}
        // TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDeleteConfirmation}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Vous êtes sur le point de supprimer cet article, êtes-vous sûr de
            vouloir poursuivre cette action ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleDelete()}
            endIcon={<DeleteIcon />}
            loading={deleteLoading}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Oui
          </LoadingButton>
          <Button
            onClick={() => handleCloseDeleteConfirmation()}
            variant="contained"
            color="inherit"
            sx={{ textTransform: "none" }}
            startIcon={<ExitToAppIcon />}
          >
            Non
          </Button>
        </DialogActions>
      </Dialog>

      <ChangeStatusConfirmation
        confirmMessage={confirmMsgForStatut}
        open={changeStatut}
        handleClose1={handleClose1}
        http={http}
        url={url}
        setOpenSnack={setOpenSnack}
        setAlerteMessage={setAlerteMessage}
        setAlertType={setAlertType}
        handleReload={RereshDataArticle}
      />

      <DesactiveDateModal
        confirmMessage={confirmMsgForStatut}
        desactiveDateModal={desactiveDateModal}
        handleClose2={handleClose2}
        url={url}
        http={http}
        setOpenSnack={setOpenSnack}
        setAlerteMessage={setAlerteMessage}
        setAlertType={setAlertType}
        handleReload={RereshDataArticle}
      />
    </>
  );
};

export default SecondNiveauArticle;
